import { render } from "./RevendedoresView.vue?vue&type=template&id=22b67553"
import script from "./RevendedoresView.vue?vue&type=script&lang=js"
export * from "./RevendedoresView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__